import React, { Fragment, useEffect, useState } from 'react';
type CountdownProps = {
  className?: string;
};
export function Countdown({
  className = ''
}: CountdownProps) {
  const [seconds, setSeconds] = useState(83027);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const units: Array<[string, number]> = [['hrs', Math.floor(seconds / 3600)], ['min', Math.floor(seconds % 3600 / 60)], ['sec', seconds % 60]];
  return <div className={`inline-flex items-center gap-2 ${className}`} aria-label="Time remaining on this offer" data-id="element-261" data-mp="1ji3jpgma3sjo">
      {units.map(([label, value], index) => <Fragment key={label} data-id="element-262" data-mp="1te6qizs2sfcy" data-mpi={index}>
          {index > 0 && <span className="font-display text-2xl font-black text-solar" data-id="element-263" data-mp="1tgja1hdhexs4">:</span>}
          <span className="flex min-w-[64px] flex-col items-center rounded-lg bg-white px-3 py-2 leading-none shadow-card" data-id="element-264" data-mp="38tm680ef24kx">
            <b className="font-display text-2xl font-black tabular-nums text-navy" data-id="element-265" data-mp="34vy3ib6hf7ih">{String(value).padStart(2, '0')}</b>
            <small className="mt-1 text-[10px] font-bold uppercase tracking-wider text-muted" data-id="element-266" data-mp="2h6i1bag0dvk2">{label}</small>
          </span>
        </Fragment>)}
    </div>;
}